export default __webpack_public_path__ + "static/media/textured-wallpaper.35d43b22.png";